import {
  Box,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";

const FeeDeduction = ( {feeDeduction, setFeeDeduction}) => {
  
  const handleFeeChange = async (event) => {
    setFeeDeduction(event.target.value);
  };
  return (
    <Box>
      <Paper
        elevation={3}
        sx={{
          padding: 3,
          borderRadius: 2,
          width: { xs: "100%", md: "60%", lg: '40%' },
        }}
      >
        <Typography variant="h6" gutterBottom>
          3.5% Processing fee
        </Typography>
        <RadioGroup
          row
          value={feeDeduction}
          onChange={handleFeeChange}
          sx={{ justifyContent: "space-between", flexDirection:{ xs: 'column', sm: 'row'},  alignItems: {xs: 'start', sm: 'center'} , mt: 1 }}
        >
          <FormControlLabel
            value="Company"
            control={<Radio color="primary" />}
            label="Organizer Pays"
            sx={{ marginRight: 2 }}
          />
  
          <Box style={{fontSize: 14, textAlign: 'center', }}>OR</Box> 
          <FormControlLabel
            value="Participants"
            control={<Radio color="primary" />}
            label="Buyer Pays"
          />
        </RadioGroup>
      </Paper>
      <Box sx={{ mt: 2 }}>
        <Typography sx={{ fontSize: 14 }}>
          A 3.5% processing fee will be paid by the {feeDeduction === 'Company' ? 'Event Organizer' : 'Ticket Buyer'}.
        </Typography>
      </Box>
    </Box>
  );
};

export default FeeDeduction;
